import { setUserAddress, userAddressList } from "@/lib/cart"
import { countries, fetchFilters, homscreen, me, updateLanguageAndCurrency, updateTranslations, userLogout, verifyOTP ,fetchCancels, fetchReturns} from "@/lib/common"
import { create } from "zustand"
import useCartStore from "./cartStore"


export const masterLanguage: { [key: string]: IMaster } = {
    EN: { label: "English", code: "EN", value: "EN", },
    AR: { label: "العربية", code: "AR", value: "AR", },
}
const masterCurrency: { [key: string]: IMaster } = {
    INR: { label: "INR", code: "INR", value: "INR" },
    AED: { label: "AED", code: "AED", value: "AED" },
}


interface IObj {
    [key: string]: any
}
interface IMaster {
    label: string,
    code: string,
    value: string

}
interface Imenu { label: string; value: string; path: string };

type States = {
    isAuth: boolean
    user: IObj
    addressList: []
    homeScreen: IObj[]
    brands: Imenu[]
    access: Imenu[]
    countries: IObj[]
    filterData: IObj[]
    sortData: IObj[]
    language?: IMaster
    currency?: IMaster
    translations: IObj
     masterCancelReasons: IMaster[]
     masterReturnReasons: IMaster[]
}


type Actions = {
    fetchHomeScreen: () => Promise<IObj>
    fetchCountries: () => Promise<IObj>
    verifyOtp: (doc: { phn_num: string, phn_cd: string, otp: string, key: string }) => Promise<IObj>
    checkAuth: () => boolean
    checkUser: () => Promise<IObj>
    logout: () => Promise<IObj>
    setAddress: (address: IObj) => Promise<IObj>
    fetchAddressList: () => Promise<IObj>
    fetchCategoryFilters: (id?: string) => Promise<IObj>
    updateUserLanguageAndCurrency: (lang?: string, currency?: string) => Promise<IObj>
    setTranslations: () => Promise<IObj>
    fetchCancelReasons:()=>Promise<IObj>
    fetchReturnReasons:()=>Promise<IObj>

}

const useCommonStore = create<States & Actions>((set, get) => ({
    isAuth: false,
    homeScreen: [],
    countries: [],
    addressList: [],
    brands:[],
    access:[],
    user: {},
    filterData: [],
    sortData: [],
    language: { label: "English", code: "EN", value: "EN" },
    currency: { label: "AED", code: "AED", value: "AED" },
    translations: {},
    masterCancelReasons:[],
    masterReturnReasons:[],
    checkAuth: () => {
        const cookies = document.cookie.split(';').map(x => x.trim());
        const tokenExists = cookies.some(cookie => cookie.startsWith('token='));
        set({ isAuth: tokenExists });
        return get().isAuth;
    },
    fetchHomeScreen: async () => {
        let result = await homscreen()
        if (result.status) {
            // console.log(result.data?.data?.desktopBrandList);

            set({ homeScreen: result.data })
            set({ brands: result.data?.data?.desktopBrandList })
            set({ access: result.data?.data?.desktopAcclist })
        }
        return result
    },
    fetchCountries: async () => {
        let result = await countries()
        if (result.status) {
            set({ countries: result.data?.list })
        }
        return result
    },
    verifyOtp: async (doc: { phn_num: string, phn_cd: string, otp: string }) => {
        let result = await verifyOTP(doc)
        if (result.status) {
            set({ isAuth: true, user: result.data })
            await useCartStore.getState().updateUserCart({ items: useCartStore.getState().cart || [] });
        }
        return result
    },
    checkUser: async () => {
        let result = await me()
        if (result.status) {
            set({ isAuth: true, user: result.data })
            if (result?.data?.lang) {
                set({ language: masterLanguage?.[result?.data?.lang] || masterLanguage.EN })
            }
            if (result?.data?.currency) {
                set({ currency: masterCurrency?.[result?.data?.currency] || masterCurrency.AED })
            }
        }
        return result
    },
    updateUserLanguageAndCurrency: async (lang?: string, currency?: string) => {
        const result = await updateLanguageAndCurrency(lang, currency)
        if (result.status) {
            if (get().isAuth) {
                await get().checkUser()
            } else {
                set({
                    language: lang ? masterLanguage?.[lang] : masterLanguage.EN,
                    currency: currency ? masterCurrency?.[currency] : masterCurrency.AED
                })
            }
        }
        return result
    },
    logout: async () => {
        let result = await userLogout()
        if (result.status) {
            set({ isAuth: false, user: {} })
        }
        return result
    },
    fetchAddressList: async () => {
        let result = await userAddressList()
        if (result.status) {
            set({ addressList: result.data?.list || [] })
        }
        return result
    },
    setAddress: async (address: IObj) => {
        let result = await setUserAddress(address)
        if (result.status) {
            set({ user: { ...get().user, address } })
        }
        return result
    },
    fetchCategoryFilters: async (id?: string) => {
        let result = await fetchFilters({ id })
        if (result.status) {
            set({ filterData: result.data?.filters || [], sortData: result.data?.sorts || [] })
        }
        return result
    },
    setTranslations:async()=>{
        let result = await updateTranslations()
        if (result.status) {
            set({ translations: result.data })
        }
        return result
    },
     fetchCancelReasons:async()=>{
        let result = await fetchCancels()
        if (result.status) {
            set({ masterCancelReasons: result.data })
        }
        return result
    },
     fetchReturnReasons:async()=>{
        let result = await fetchReturns()
        if (result.status) {
            set({ masterReturnReasons: result.data })
        }
        return result
    }
}))


export default useCommonStore